import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Redux setup
import { Provider, useDispatch } from 'react-redux';
import store from './reducer/store';
import { fetchUser } from './reducer/userActions'; // import your fetchUser action


// This component runs once on app load to fetch user
const AppContainer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const accessToken = localStorage.getItem("teslaUserAccessToken");
    if (accessToken) {
      dispatch(fetchUser());
    }
  }, [dispatch]);

  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppContainer />
    </Provider>
  </React.StrictMode>
);

// Optional: performance measuring
reportWebVitals();
